import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import Layout from 'hb-react/shared/apps/Events/components/Layout/';
import { RegistrationSteps } from 'hb-react/shared/apps/Events/constants/registrationSteps';
import { useDonationsContext } from 'hb-react/shared/apps/Events/contexts/DonationsContext';
import { useEventCartContext } from 'hb-react/shared/apps/Events/contexts/EventCartContext';
import { useEventContext } from 'hb-react/shared/apps/Events/contexts/EventContext';
import { useRegistrationFlowContext } from 'hb-react/shared/apps/Events/contexts/RegistrationFlowContext';
import {
  hideFooterFrontLinks,
  showFooterFrontLinks,
} from 'hb-react/shared/utils/footerFrontLinks';

import BillingInformationStep from './components/BillingInformationStep';
import TicketInformationStep from './components/TicketInformationStep';
import TicketSelectionStep from './components/TicketSelectionStep';
import { useNavigation as useBreadcrumbs } from './hooks/useNavigation';
import DonationModal from '../Donation';
import EventRegistrationSidebar from '../EventRegistrationSidebar';

const Step = ({ currentStep }) => {
  switch (currentStep) {
    case RegistrationSteps.TICKET_SELECTION_STEP:
      return <TicketSelectionStep />;
    case RegistrationSteps.TICKET_INFORMATION_STEP:
      return (
        <EventRegistrationControl>
          <TicketInformationStep />
        </EventRegistrationControl>
      );
    case RegistrationSteps.BILLING_INFORMATION_STEP:
      return (
        <EventRegistrationControl>
          <BillingInformationStep />
        </EventRegistrationControl>
      );
    default:
      throw new Error(`Unknow step ${currentStep}`);
  }
};

const EventRegistrationControl = ({ children }) => {
  const navigate = useNavigate();
  const { eventDetailsPageLink } = useEventContext();
  const { orderCompleted } = useEventCartContext();

  useEffect(() => {
    if (orderCompleted) {
      navigate(eventDetailsPageLink);
    }
  }, [orderCompleted, eventDetailsPageLink, navigate]);

  if (orderCompleted) {
    return null;
  }

  return children;
};

const EventRegistrationContainer = () => {
  const { event, eventDetailsPageLink } = useEventContext();
  const navigate = useNavigate();
  const breadcrumbs = useBreadcrumbs();

  const {
    donations,
    isDonationModalOpen,
    closeModal,
    onSubmit,
    onSubmitSuccess,
  } = useDonationsContext();

  const {
    registrationFlow: { currentStep },
  } = useRegistrationFlowContext();

  useEffect(() => {
    if (event.cancelled) {
      navigate(eventDetailsPageLink);
    }
  }, [event]);

  useEffect(() => {
    hideFooterFrontLinks();

    return () => showFooterFrontLinks();
  }, []);

  return (
    <Layout
      navigation={breadcrumbs}
      sidebar={
        event && <EventRegistrationSidebar event={event} withShoppingCard />
      }
    >
      <>
        <Step currentStep={currentStep} />
        <DonationModal
          header={event?.donation_overlay_headline}
          opened={isDonationModalOpen}
          donations={donations}
          onSubmit={onSubmit}
          onSubmitSuccess={onSubmitSuccess}
          onClose={() => closeModal()}
        />
      </>
    </Layout>
  );
};

export default EventRegistrationContainer;
